export default {

    // convert to array
    convertArray(type) {
        if (type !== null) {
            return type.split(',').map(Number);
        }
    },

    // split string
    splitStringLinks(links) {
        let str = links.split('?');
        return str[1];
    },

    // filter data
    filterData(data, search) {
        let result = data;
        if (search !== "") {
            result = result.filter((row) => {
                return Object.keys(row).some((key) => {
                    return (String(row[key]).toLowerCase().indexOf(search.toLowerCase()) > -1);
                })
            });
        }
        return result;
    },

    // convert data to pagination at frontend
    paginateData(array, pagination) {
        pagination.from = array.length ? ((pagination.currentPage - 1) * pagination.perPage) + 1 : ' ';
        pagination.to = pagination.currentPage * pagination.perPage > array.length ? array.length : pagination.currentPage * pagination.perPage;
        pagination.prevPage = pagination.currentPage > 1 ? pagination.currentPage : '';
        pagination.nextPage = array.length > pagination.to ? pagination.currentPage + 1 : '';
        pagination.page = Math.ceil(array.length / pagination.perPage);
        pagination.total = array.length;
        return array.slice((pagination.currentPage - 1) * pagination.perPage, pagination.currentPage * pagination.perPage);
    },

    pagination(res) {
        let pagination = {
            current_page: res.current_page,
            last_page: res.last_page,
            next_page_url: res.next_page_url,
            prev_page_url: res.prev_page_url,
            from_page: res.from,
            to_page: res.to,
            total_page: res.total
        };

        return pagination;
    },

    paginationParams() {
      let pagination = {
            perPage: 10,
            perPageOptions: [5, 10, 25, 50],
            currentPage:1,
            nextPage:'',
            prevPage:'',
            total:'',
            from:'',
            to:'',
            page:'',
      };
      return pagination;
    }
};
